import { FC, useMemo } from 'react';
import { ICellRendererParams } from 'ag-grid-community';

const CheckmateEmailLinkRenderer: FC<ICellRendererParams> = (props: ICellRendererParams) => {
    const href = useMemo(() => {
        if (Array.isArray(props.value) && props.value.length) {
            return props.value.map((value) => {
                return `mailto:${value}`;
            })
        }
        if (props.value) {
            return `mailto:${props.value}`
        }
        return '';
    }, [props.value]);
    return  <div className="line-break-cell">
        {Array.isArray(href) && href.map((innerRef, index) => {
            return <div key={index}><a href={innerRef}>{props.value[index]}</a><br/></div>
        })}
        {!Array.isArray(href) && !!href && <a href={href}>{props.value}</a>}
    </div>
};

export default CheckmateEmailLinkRenderer